import { ImageCachePathDimensions } from '@synergy/models';
import { PoolImage } from '@synergy/components-next';
import { ReactElement } from 'react';

import { Supplier } from '../../models/supplier';

export interface ArticlePlaceholderImageProps {
    supplier: Partial<Supplier>;
    imageSrc?: string;
    imageCachePath: ImageCachePathDimensions;
    height?: number | string;
    width?: number | string;
    minHeight?: number | string;
    maxWidth?: number | string;
}

export const ArticlePlaceholderImage = (props: ArticlePlaceholderImageProps): ReactElement => {
    const { supplier, imageCachePath, height = '100%', width = '100%', minHeight, maxWidth } = props;
    const { name, image } = supplier;

    return (
        <PoolImage
            component="img"
            src={image?.[imageCachePath]}
            alt={name ? `${name}-logo` : 'supplier-logo'}
            sx={{
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                objectFit: 'contain',
                width,
                height,
                minHeight,
                maxWidth,
                maxHeight: 616,
            }}
        />
    );
};
